export default {
  navigationBarTitleText: '分流页面',
};
